var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseCard',[_c('BaseCardHeader',[_vm._v(" Permissions ")]),_c('BaseCardBody',[_c('PermissionsManager',{attrs:{"role-id":_vm.role.id,"can-edit":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }